import { RightArrowIcon, TickMarkIcon } from '@sketchnote/icons';
import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';

export interface HelpComponentProps {
  heading: string;
  contentOne?: string;
  contentTwo?: string;
  contentThree?: string;
  icon?: string;
  link: string;
  linkOne?: string;
  linkTwo?: string;
  linkThree?: string;
}

export const HelpComponent = ({
  heading,
  contentOne,
  contentTwo,
  contentThree,
  icon,
  link,
  linkOne,
  linkTwo,
  linkThree,
}: HelpComponentProps): JSX.Element => {
  return (
    <div className="p-24 flex flex-col  mobile:h-332 tablet:h-332 tablet:w-304 mobile:w-284 border rounded-md tablet:m-18 mobile:mb-32">
      <div className="flex justify-between mb-24">
        <p className="text-gray-600 text-sm">{heading}</p>
        <p>
          <img alt="help" src={icon} className="w-32 h-32" />
        </p>
      </div>
      <div className="flex flex-col flex-grow relative">
        <div>
          {linkOne !== undefined && (
            <Link href={linkOne}>
              <a className="text-blue-800 mb-12 font-medium text-left block">{contentOne}</a>
            </Link>
          )}
          {linkTwo !== undefined && (
            <Link href={linkTwo}>
              <a className="text-blue-800 mb-12 font-medium text-left block">{contentTwo}</a>
            </Link>
          )}
          {linkThree !== undefined && (
            <Link href={linkThree}>
              <a className="text-blue-800 mb-48 font-medium text-left block">{contentThree}</a>
            </Link>
          )}
        </div>
        <div className="align-bottom absolute bottom-0">
          <Link href={link}>
            <a
              className={classNames({
                'text-blue-500 text-sm font-medium text-left block': true,
              })}
            >
              <span>Learn More&nbsp;</span>
              <RightArrowIcon className="text-sm text-blue-500 ml-10 pt-4" />
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};
